<section id="ai-assist-manager">
  <app-hamburger-wrapper></app-hamburger-wrapper>
  <app-manager-header [title]="'Kyloe AI NoteTaker Manager'"></app-manager-header>

  @if (clientConfig?.notetakerEnabled) {
    <section class="content scroll-container" >
      <article>
        <h2 class="heading-underline">Questions for {{ corpIdDisplay }}
          @if (questionsDataSource.length > 0) {
            <span class="clear-input">
              <input #searchInput type="text" class="input-search-field" [ngModel]="searchText" placeholder="Search questions...">
              <i
                [ngClass]="searchText ? 'bhi-times' : 'bhi-search'"
                class="clear-icon"
                (click)="clearInput(searchInput, true)"
                (keydown.enter)="clearInput(searchInput, true)"
                [matTooltip]="searchText ? 'Clear' : ''"
                matTooltipShowDelay="500"
                tabindex="0"
                #clearSearch>
              </i>
            </span>
          }
        </h2>
        <section class="scrollable-container">
          <div>
            <table mat-table [dataSource]="filteredQuestions" matSort class="table-striped row-highlight">
              <ng-container matColumnDef="question">
                <th mat-header-cell *matHeaderCellDef> Question </th>
                <td mat-cell *matCellDef="let element">
                  {{ element.meta?.question }}
                </td>
              </ng-container>
              <ng-container matColumnDef="field">
                <th mat-header-cell *matHeaderCellDef> Field </th>
                <td mat-cell *matCellDef="let element">
                  {{ element.field }}
                </td>
              </ng-container>
              <ng-container matColumnDef="entityType">
                <th mat-header-cell *matHeaderCellDef> Type </th>
                <td mat-cell *matCellDef="let element">
                  {{ element.entityType }}
                </td>
              </ng-container>
              <ng-container matColumnDef="action">
                <th mat-header-cell *matHeaderCellDef> Action </th>
                <td mat-cell *matCellDef="let element">
                  @if (getStyle(element) !== 'SUMMARY') {
                    <mat-icon
                      matTooltip="Delete"
                      class="danger-btn-hover"
                      (click)="delete(element, $event); $event.stopPropagation()"
                      fontIcon="delete_outline">
                    </mat-icon>
                  }
                </td>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="['question', 'field', 'entityType', 'action']"></tr>
              <tr mat-row *matRowDef="let row; columns: ['question', 'field', 'entityType', 'action'];"
                (click)="showModal(row)"
                class="clickable-row">
              </tr>
            </table>
          </div>
        </section>
        <section class="footer-btns">
          <button (click)="showModal()">Create new Question<mat-icon class="add-button" fontIcon="add"></mat-icon></button>
        </section>
      </article>
    </section>
  }
  <div id="version-number" [ngClass]="{'expand-version': expandVersion}" title="Double click to copy -
                  {{environment.environmentIdentifier}} v{{appVersion}}"
    (dblclick)="copyToClipboard(environment.environmentIdentifier + ' v' + appVersion)">
    @if (environment.environmentIdentifier !== 'PROD') {
      ENV: {{ environment.environmentIdentifier }}
    }
    v{{ appVersion }}
  </div>
</section>
